import apiClient from '@/config/api';

export interface ScreenRanking {
  screen: string;
  pv: number;
  uv: number;
}

export interface ScreenViewsOverview {
  periodDays: 7 | 30 | 90;
  ranking: ScreenRanking[];
  topScreens: string[];
  dailyTrend: Array<Record<string, string | number>>;
}

export interface FunnelStep {
  key: string;
  label: string;
  uu: number;
  conversionRate?: number;
}

export interface FunnelOverview {
  periodDays: 7 | 30 | 90;
  matchRequestScreens: string[];
  steps: FunnelStep[];
}

export const screenAnalyticsApi = {
  getScreenViews: async (days: 7 | 30 | 90): Promise<ScreenViewsOverview> => {
    const res = await apiClient.get('/admin/analytics/screen-views', {
      params: { days: String(days) },
    });
    return res.data.data;
  },
  getFunnel: async (days: 7 | 30 | 90): Promise<FunnelOverview> => {
    const res = await apiClient.get('/admin/analytics/funnel', {
      params: { days: String(days) },
    });
    return res.data.data;
  },
};
